import {
  SearchProductLabel,
  SearchProductLabelType,
} from '@epicuro-next/models/products';
import { ProductLabelType } from 'graphql-api/gql-api-interfaces';

export function mapProductLabels(labels: SearchProductLabel[] = []) {
  const labelTypeMapping: {
    [key in SearchProductLabelType]: ProductLabelType;
  } = {
    [SearchProductLabelType.Badge]: ProductLabelType.Badge,
    [SearchProductLabelType.Frame]: ProductLabelType.Frame,
    [SearchProductLabelType.Icon]: ProductLabelType.Icon,
  };

  return labels.map((e) => ({
    name: e.name,
    labelType: labelTypeMapping[e.labelType],
    data: Object.fromEntries(
      // cut ';' from css style properties
      Object.entries(e.data ?? {}).map(([key, value]) => [
        key,
        value?.replace(/;$/, ''),
      ]),
    ),
  }));
}
